/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JoinLogDto } from '../../models/join-log-dto';

export interface CenterJoinLogControllerCancelJoinRequest$Params {

/**
 * 가입 요청 ID
 */
  id: string;
}

export function centerJoinLogControllerCancelJoinRequest(http: HttpClient, rootUrl: string, params: CenterJoinLogControllerCancelJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<JoinLogDto>> {
  const rb = new RequestBuilder(rootUrl, centerJoinLogControllerCancelJoinRequest.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<JoinLogDto>;
    })
  );
}

centerJoinLogControllerCancelJoinRequest.PATH = '/api/center-join-log/join/{id}/cancel';
